import { Component, Input, OnInit,HostListener  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpApiService, IHelp } from '@ebb-v2/ebb-integration';
import { NavigationService } from '../../services/navigationservice/navigation.service';

@Component({
  selector: 'program-closed',
  templateUrl: './program-closed.component.html',
  styleUrls: ['./program-closed.component.scss']
})

export class ProgramClosedComponent implements OnInit {
  public listHelp: IHelp[] = [];
  public message: string;
  public showMessage:boolean =false;
  public type: string;

  constructor( private readonly apiHelp: HelpApiService,private route: ActivatedRoute,private navigationService: NavigationService, private router: Router) { 

    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');

     
     
    });
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event): void {
    this.navigationService.markAsRefreshed();
  }
  ngOnInit() {
    this.checkIfPageIsRefreshed();
    this.loadHelpText();
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          var help ="";
          if(this.type=="ebb")  {
            help ="EBB Program ClosedMessage";
          }
          if(this.type=="ess")  {
            help ="ESS Program Closed Message";
          }
          if(this.type=="ceabb")  {
            help ="CEA BB Program Closed Message";
          }
          const indexHelpContractor = this.listHelp.findIndex(i => i.name === help);
          this.message = this.listHelp[indexHelpContractor].answer;
          this.showMessage = true;
        },
        error => console.log(error)
      );
  }
  private checkIfPageIsRefreshed(): void {
    const performance = window.performance ;

    if (performance && performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      this.navigationService.markAsRefreshed();
      this.router.navigate(['']); // Redirect to the home page
    } else {
      this.navigationService.markAsNotRefreshed();
    }
  }
}
